import { appConfig } from "@/lib/appConfig";
import { defaultHttpResHandler } from "@/store/helpers/defaultHttpResHandler";
import { makeGetReq, makePostReq } from "@/store/helpers/request";

export const fetchAllNotes = async (token, page, limit, sort) => await defaultHttpResHandler(async () => await makeGetReq(appConfig.domain + '/note?page=' + page + '&limit=' + limit + '&sortOrder=' + sort, { token }));
export const createNote = async (token, data) => await defaultHttpResHandler(async () => await makePostReq(appConfig.domain + '/note', data, { token, data: true }));

